var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"box-blue"},[_c('ul',{staticClass:"search-wrap"},[_c('li',[_c('button',{staticClass:"btn sub-btn btn-basic-outline",on:{"click":_vm.openAddPopup}},[_vm._v(_vm._s(_vm.$t('등록')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }